import React from 'react';

/**
 * How many items a list holds, as the toolbar says it: "1 item", "12 items".
 *
 * Nothing is said until the list has answered for what is on screen: "0 items"
 * drawn while the first page is in flight (a slow API, a cold card cache after
 * in-app navigation) reads as an answer, and on the review queue it says a
 * submission that is there is not. Nor is anything said when the first page
 * failed: nothing answered.
 */
export default function ListCount({ count, loading = false, failed = false, singular = 'item', plural = 'items' }) {
	const unanswered = loading || failed;
	return (
		<span className="items-page__count" aria-busy={loading || undefined}>
			{unanswered ? '' : (count === 1 ? `1 ${singular}` : `${count} ${plural}`)}
		</span>
	);
}
